// Témoignages clients représentatifs (style Google 5 étoiles)
export const TESTIMONIALS = [
  {
    name: "Catherine D.",
    city: "Caen",
    rating: 5,
    date: "Mars 2025",
    text: "Travail professionnel, discret et rapide. L'équipe est à l'écoute et a su transformer notre jardin. Nous recommandons vivement Les Jardiniers Normands.",
  },
  {
    name: "Philippe M.",
    city: "Hérouville-Saint-Clair",
    rating: 5,
    date: "Février 2025",
    text: "Élagage de deux grands chênes en milieu urbain. Travail soigné, chantier nettoyé impeccablement. Très contente, rapide et efficace, je recommande.",
  },
  {
    name: "Sophie L.",
    city: "Deauville",
    rating: 5,
    date: "Janvier 2025",
    text: "Excellent paysagiste, une création de jardin de A à Z chez nous à Deauville. Vrai sens du détail, respect des délais, prix juste. Bravo !",
  },
  {
    name: "Jean-Pierre R.",
    city: "Lisieux",
    rating: 5,
    date: "Décembre 2024",
    text: "Démoussage complet de notre toiture et nettoyage de la façade. Résultat bluffant, comme neuf. Équipe professionnelle et bien équipée.",
  },
  {
    name: "Marie F.",
    city: "Ouistreham",
    rating: 5,
    date: "Novembre 2024",
    text: "Contrat d'entretien annuel depuis 2 ans. Jardin toujours impeccable, intervention régulière sans avoir à s'en soucier. Crédit d'impôt en plus, parfait.",
  },
  {
    name: "Antoine B.",
    city: "Caen",
    rating: 5,
    date: "Octobre 2024",
    text: "Abattage d'un grand peuplier en milieu très contraint (proximité maison + ligne électrique). Travail réalisé en démontage avec rétention, parfaitement maîtrisé.",
  },
  {
    name: "Isabelle V.",
    city: "Trouville-sur-Mer",
    rating: 5,
    date: "Septembre 2024",
    text: "Taille de toutes les haies de notre propriété et entretien complet du jardin. Équipe ponctuelle, sérieuse, prix correct. Je referai appel à eux sans hésiter.",
  },
  {
    name: "Bruno T.",
    city: "Falaise",
    rating: 5,
    date: "Août 2024",
    text: "Dessouchage de 4 souches anciennes en pleine pelouse. Terrain parfaitement remis en état. Belle prestation, je recommande Pro Élagage 14.",
  },
  {
    name: "Nathalie P.",
    city: "Bayeux",
    rating: 5,
    date: "Juillet 2024",
    text: "Création complète d'un jardin paysager autour de notre nouvelle maison. Conseils avisés sur les essences locales, plantations magnifiques. Très satisfaite.",
  },
];
